module.exports = __webpack_public_path__ + "media/images/webhooks/real_time_and_post_call-4c3a835533907060f14be35ba53f3e55.png";